export default __webpack_public_path__ + "static/media/coins.4fa5ff03.png";